import { LoadStatus } from '@servicetitan/cp-ui';
import { inject, injectable } from '@servicetitan/react-ioc';
import { SchedulerApi, SettingsApi } from 'api';
import { makeObservable, observable, runInAction } from 'mobx';

export enum DynamicSchedulerType {
    None = 0,
    SchedulingPro = 1,
    WebScheduler2 = 2,
}

export interface DynamicScheduler {
    type: DynamicSchedulerType;
    id?: string | number;
    dataApiKey?: string;
    publicCode?: string;
    schedulingProEmbedScriptUrl?: string;
    webSchedulerScriptUrl?: string;
}

@injectable()
export class SchedulerStore {
    @observable loadStatus = LoadStatus.None;
    @observable scheduler?: DynamicScheduler;

    constructor(
        @inject(SettingsApi) private settingsApi: SettingsApi,
        @inject(SchedulerApi) private schedulerApi: SchedulerApi
    ) {
        makeObservable(this);
    }

    loadSchedulerSettings = async () => {
        if (this.loadStatus === LoadStatus.Loading) {
            return;
        }

        runInAction(() => (this.loadStatus = LoadStatus.Loading));

        try {
            const [schedulerSettings, scheduler] = await Promise.all([
                this.settingsApi.schedulerSettingsClient.getSchedulerSettings(),
                this.schedulerApi.getScheduler(),
            ]);
            runInAction(() => {
                if (scheduler) {
                    this.scheduler = scheduler;
                    this.scheduler.schedulingProEmbedScriptUrl =
                        schedulerSettings.schedulingProScriptUrl;
                    this.scheduler.webSchedulerScriptUrl = schedulerSettings.webSchedulerScriptUrl;
                    this.loadStatus = LoadStatus.Ok;
                }
            });
        } catch {
            runInAction(() => (this.loadStatus = LoadStatus.Error));
        }
    };
}
